import { type IFileObjectDTO } from '../../../models/fileObjects';
import { baseLearningTools, baseLearningVideos } from '../fixtures/content';
import { clone } from '../support/clone';

/**
 * Returns the mock learning tools.
 */
export function getDevMockLearningTools(): IFileObjectDTO[] {
  return clone(baseLearningTools);
}

/**
 * Returns the mock Workshop Library playlist.
 */
export function getDevMockLearningVideos() {
  return clone(baseLearningVideos);
}
